import dayjs from 'dayjs';

import type { HeaderNotificationListItem } from '@/features/notifications/types/headerNotification.types';
import { HEADER_NOTIFICATION_SEED } from '@/mocks/headerNotifications';

/**
 * Tạo danh sách từ seed: thời điểm tương đối tính tại thời điểm gọi.
 */
export function buildSeedHeaderNotificationItems(
  t: (key: string, options?: Record<string, string | number>) => string,
  readIds: Set<string>,
): HeaderNotificationListItem[] {
  return HEADER_NOTIFICATION_SEED.map((s) => {
    const occurredAt = dayjs()
      .subtract(s.recency.value, s.recency.unit === 'hour' ? 'hour' : 'day')
      .toISOString();
    return {
      id: s.id,
      source: 'seed',
      category: s.category,
      severity: s.severity ?? 'info',
      title: t(s.titleKey, s.titleParams),
      timeLabel: t(s.timeKey),
      read: readIds.has(s.id),
      actionKind: s.actionKind ?? 'navigate',
      stationId: s.stationId,
      iotStationNameContains: s.iotStationNameContains,
      actionPath: s.actionPath,
      occurredAt,
    };
  });
}
